<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="closeValveDevice"></gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					:storageKey="`localcolumn-closevalve-device`"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show">
				<gc-table
					:columns="columnList"
					:table-data="tableData"
					:border="true"
					:showPage="true"
					:total="page.total"
					:page-size="page.size"
					:currentPage="page.current"
					@current-page-change="
						currentPage => {
							currentPageChange(currentPage, apiGetDeviceList)
						}
					"
					@size-change="
						size => {
							page.size = size
							currentPageChange(1, apiGetDeviceList)
						}
					"
				></gc-table>
			</div>
		</div>
	</div>
</template>

<script>
import { apiGetDeviceList, apiGetDeviceTypeList } from '@/apis/account.api.js'
import common from '../mixins/common.js'
import { has } from '@/utils/business'
import { isBlank } from '@/utils/validate'

const valveStatusMap = {
	0: '强关',
	6: '普关',
}
export default {
	name: 'closevalveDevice',
	mixins: [common],
	data() {
		return {
			form: {
				deviceNo: null,
				designNo: null,
				userName: null,
				userNo: null,
				address: null,
				deviceTypeClassify: '1',
				deviceTypeIdList: null,
				deviceStatus: null,
				valveStatus: '0,6',
			},
			columns: [
				{
					key: 'deviceNo',
					name: '设备通讯编号',
				},
				{
					key: 'designNo',
					name: '外观编号',
				},
				{
					key: 'deviceTypeName',
					name: '设备类型',
				},
				{
					key: 'lastCommunicateTime',
					name: '最后通讯时间',
				},
				{
					key: 'deviceStatusName',
					name: '设备状态',
					render: (h, row) => {
						let val = row.deviceStatus
						let statusMap = {
							0: { class: 'dot-error', text: '待安装' },
							1: { class: 'dot-success', text: '已安装' },
							2: { class: 'dot-message', text: '已拆除' },
						}
						return h(
							'span',
							{ class: isBlank(val) ? '' : statusMap[val]['class'] },
							isBlank(val) ? '--' : statusMap[val]['text'],
						)
					},
				},
				{
					key: 'valveStatus',
					name: '阀门状态',
					render: (h, row) => {
						return h('span', null, valveStatusMap[row.valveStatus] || '-')
					},
				},
				has('monitor:device:account:record:alarm')
					? {
							key: 'oprate',
							name: '操作',
							render: (h, row) => {
								return h(
									'el-button',
									{
										props: {
											type: 'text',
											size: 'medium',
										},
										on: {
											click: () => {
												this.$router.push({
													name: 'deviceDetail',
													query: {
														deviceId: row.deviceId,
														deviceType: row.deviceTypeId,
													},
												})
											},
										},
									},
									'查看详情',
								)
							},
					  }
					: null,
			].filter(Boolean),
			options: {
				valveStatus: [
					{ label: '全部', value: '0,6' },
					{ label: '强关', value: '0' },
					{ label: '普关', value: '6' },
				],
			},
		}
	},
	computed: {
		columnList() {
			return this.columns.filter(o => o.selected)
		},

		deviceStatusOptions() {
			return this.$store.getters?.dataList?.deviceStatus
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},
		filterFields() {
			return [
				{ prop: 'deviceNo', label: '设备通讯编号', type: 'input' },
				{ prop: 'designNo', label: '外观编号', type: 'input' },
				{ prop: 'userName', label: '客户/站点名称', type: 'input' },
				{ prop: 'userNo', label: '用户号', type: 'input' },
				{ prop: 'address', label: '安装地址', type: 'input' },
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.options.deviceTypeId,
						filterable: true,
						needAllForSearch: true,
						multiple: true,
					},
				},
				{
					prop: 'deviceStatus',
					label: '设备状态',
					type: 'select',
					props: {
						searchOption: this.deviceStatusOptions,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'valveStatus',
					label: '阀门状态',
					type: 'select',
					props: {
						searchOption: this.options.valveStatus,
						needAllForSearch: false,
					},
				},
			]
		},
	},

	mounted() {
		if (this.$route.params?.valveStatus) {
			this.form.valveStatus = this.$route.params.valveStatus
			this.form.deviceStatus = this.$route.params.deviceStatus
		}
		this.queryDeviceTypeList()
		this.getList(1, apiGetDeviceList)
	},

	methods: {
		apiGetDeviceList,
		handleFilterSearch() {
			this.getList(1, apiGetDeviceList)
		},
		handleFilterReset() {
			this.getList(1, apiGetDeviceList)
		},

		async queryDeviceTypeList() {
			const data = await apiGetDeviceTypeList({
				tenantId: this.tenantId,
				deviceTypeClassify: this.form.deviceTypeClassify,
			})
			this.$set(
				this.options,
				'deviceTypeId',
				(data.records || []).map(item => {
					return {
						value: item.deviceTypeId,
						label: item.deviceTypeName,
					}
				}),
			)
		},
	},

	activated() {
		if (this.$route.params?.update) {
			this.form = this.$options.data().form
			this.form.valveStatus = this.$route.params.valveStatus
			this.form.deviceStatus = this.$route.params.deviceStatus
			this.getList(1, apiGetDeviceList)
		}
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
</style>
